class UpsellSelector extends HTMLElement {
  constructor() {
    super();
    this.productsToAdd = [];
  }

  connectedCallback() {
    this.initializeFormHandling();
    this.quantityUpdate();
  }

  initializeFormHandling() {
    const updateProductsToAdd = () => {
      this.productsToAdd = [];

      document.querySelectorAll('.MA-product-addon__item').forEach(container => {
        const variantId = container.querySelector('.MA-variant-id')?.value;
        const quantityInput = container.querySelector('.MA-quantity__input');
        const quantity = quantityInput ? parseInt(quantityInput.value) : 0;
        console.log(quantity);
        const checkbox = container.querySelector('.MA-checkbox');

        if (checkbox.checked) {
          if (variantId && !isNaN(quantity) && quantity > 0) {
            this.productsToAdd.push({ id: variantId, quantity });
          }
        }
      });

      console.log('Updated productsToAdd:', this.productsToAdd);
    };

    this.querySelectorAll('.MA-checkbox').forEach(checkbox => {
      checkbox.addEventListener('change', updateProductsToAdd);
    });

    document.addEventListener('cartAllProcessEnded', () => {
      console.log(this.productsToAdd);
      updateProductsToAdd();
      if (this.productsToAdd.length) {
        this.addProductsToCart(this.productsToAdd);
      } else {
        console.warn('No products selected to add to cart.');
      }
    });
  }

  async addProductsToCart(products) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: products }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Products successfully added to cart:', data);
        document.querySelectorAll('.MA-product-addon__item').forEach(container => {
          const checkbox = container.querySelector('.MA-checkbox');
          checkbox.checked = false;
        });
        document.dispatchEvent(new CustomEvent('updateCart', {bubbles: true}));
      } else {
        console.error('Failed to add products:', response.statusText);
      }
    } catch (error) {
      console.error('Error while adding products to cart:', error);
    }
  }

  quantityUpdate(){
    document.querySelectorAll('.MA-quantity-selector').forEach(selector => {
      const input = selector.querySelector('.MA-quantity__input');
      const [decreaseButton, increaseButton] = selector.querySelectorAll('.MA-quantity-selector__button');
      
      const min = +input.min || 1;
      const max = +input.max || Infinity;
      const step = +input.step || 1;
      
      decreaseButton.onclick = () => input.value = Math.max(min, +input.value - step);
      increaseButton.onclick = () => input.value = Math.min(max, +input.value + step);
      
      input.oninput = () => input.value = Math.max(min, Math.min(max, +input.value || min));
    });
  }
}

customElements.define('ma-upsell-selector', UpsellSelector);
